import React, {Component} from 'react';

export default class Footer extends Component {

  render() {

    return (
     <nav className="  navbar-default navbar-fixed-bottom">
        <div className="container-fluid">
          <div className="navbar-header">
          </div>
          <ul className="nav navbar-nav navbar-right">
          </ul>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Footer.js